var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
    _vm.loaded
      ? _c(
          "div",
          { key: "player", staticClass: "t-vplayer t-vplayer--embed" },
          [
            _c(
              "div",
              { staticClass: "t-vplayer__main" },
              [
                _vm.video.accessUrl
                  ? _c("video-player", {
                      attrs: { video: _vm.video, embed: true },
                      on: { video_loaded: _vm.startTracker }
                    })
                  : _vm.video.deleted
                  ? _c("video-not-available", { key: "video-not-found" })
                  : _vm._e()
              ],
              1
            )
          ]
        )
      : _c(
          "div",
          { key: "loader", staticClass: "t-vplayer__loader" },
          [
            _c("loader"),
            _vm._v(" "),
            _c("div", { staticClass: "t-fs--h5 t-tc--muted t-mar--t-xs" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("player.loading.video")) + "\n    "
              )
            ])
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }